<template>
  <div class="report">
    <mu-container>
        <mu-form :model="form" class="mu-demo-form" label-position="top" label-width="100">
      <mu-row gutter>
        
        <mu-col span="12" lg="12" sm="12">
          <mu-date-input
            v-model="form.month"
            label="选择日期"
            value-format="YYYY-MM"
            @change="getIncomeCost()"
            label-float
            full-width
            no-display
            type="month"
            
          ></mu-date-input>
        </mu-col>
        
        
      </mu-row>
      </mu-form>
    </mu-container>
    <mu-container>
      <mu-row>
        <el-table
          v-loading="loading"
          :data="income_costs"
          border
          show-summary
          stripe
          style="width: 100%; text-align: center"
          class="budget_list"
          :summary-method="getSummaries"
          height="600"
          ref="table"
        >
          <el-table-column prop="cost_account.title" label="机构名称"  fixed="left">
            <template slot-scope="scope">
              <span
                @click="lookup(scope.row)"
                type="text"
                style="color: #3f51b5"
                >{{ scope.row.cost_center }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="budget_year" label="预算年月">
          </el-table-column> -->
          <el-table-column prop="target_income" sortable label="预计收款">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.target_income).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="collected" sortable label="当月收款">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.collected).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cost" sortable label="当月支出">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.cost).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="profit" sortable label="净流量">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.profit).toLocaleString() }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="budget_rest" sortable label="剩余">
            <template slot-scope="scope">
              <span>{{ scope.row.budget_rest.toLocaleString()}}</span>
            </template>
          </el-table-column> -->
        </el-table>
      </mu-row>
    </mu-container>

    <Footer active="Report"></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "../../components/Report/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer,
  },
  data() {
    return {
      form: {
        month: "",
      },
      today:new Date(),
      income_costs: [],
      columns: [
        { title: "机构名称", name: "jgmc" },
        // { title: "预算年月", name: "budget_year", align: "center" },
        { title: "预计收款", name: "target_income", align: "center", sortable: true },
        { title: "当月收款", name: "dysk", align: "center", sortable: true },
        { title: "当月支出", name: "dysr", align: "center", sortable: true },
        { title: "净流量", name: "drsk", align: "center", sortable: true },
      ],
      loading:true,
    };
  },
  created() {
    document.title = "收入费用一览表（按月份）";
    this.getDate();
  },
  methods: {
    getDate() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      // let H = Da.getHours();
      // let mm = Da.getMinutes();
      // let s=d.getSeconds()
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      // H = H < 10 ? "0" + H : H;
      this.form.month = y+ '-'+m;
      // this.maxMonth = y + "-" + m + "-" + d;
      // this.today = y + "-" + m + "-" + d;
      this.getIncomeCost();
    },
    getIncomeCost() {
      this.$http.post("report/income_cost", this.form).then((res) => {
        if(res.data.code == 204){
          this.$router.push({name:'Login'});  
          return false;
        }
        if (res.data.code != 200) {
          this.$dialog
            .alert({
              message: res.data.msg,
            })
            .then(() => {
              this.$router.push({ name: "Report" });
            });
        }
        this.income_costs = res.data.data;
        this.loading = false;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = parseInt(sums[index]).toLocaleString();
          // console.log(sums[index])
          // sums[index] += ' 元';
        } else {
          // sums[index] = 'N/A';
          sums[index] = "";
        }
      });

      return sums;
    },
  },
  updated(){
    this.$nextTick(() => {
      this.$refs['table'].doLayout();
    }) 

  }
};
</script>
<style scoped>
.flow {
  font-size: 14px;
}
.mu-row {
  border-collapse: collapse;
}
.mu-col {
  margin: 0px -1px -1px 0px;
  border: solid #000 1px;
  padding: 4px 10px;
  line-height: 20px;
  text-align: left;
}
.mu-form-item{
    min-height:12px !important;
}
</style>

<style>
.budget_list .cell {
  text-align: center;
  font-weight: bold;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.budget_title {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 9999;
}
.budget_detail {
  margin: 75px auto 10px auto;
}
.budget_detail .cell {
  text-align: center;
  font-weight: bold;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.report_table {
  width: 100% !important;
}
.report_table .mu-table-header {
  width: 100% !important;
}

.report {
  margin-bottom: 90px;
  padding: 5px;
}
.report .amount {
  text-align: center;
  font-weight: bold;
}
.select_top {
  font-weight: bold;
  text-align: center;
  color: #000000;
  margin: 10px auto;
  font-size: 20px;
}
.mu-dialog-fullscreen .mu-dialog-body {
  padding: 0;
  max-height: 1200px !important;
}
</style>


